import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { nanoid } from 'nanoid';
import { useCallback, useMemo, useState } from 'react';
import { isDark } from '../common/utils';
import { SkeletonRow } from './skeleton-row';
import styles from './skeleton.module.scss';
const Skeleton = ({ rows = 4, rowHeight = 10, blocks = 1, showCircle = false, animate = false, style, RTL = false, }) => {
    const [skeletonBlocks, setSkeletonBlocks] = useState(Array.from({ length: blocks }).map(() => ({
        id: nanoid(),
        rows: Array.from({ length: rows }).map(() => ({
            id: nanoid(),
            visible: false,
            width: 0,
        })),
    })));
    const onInit = useCallback((node) => {
        if (node) {
            const width = node.clientWidth - 30;
            const width2 = Math.round(width / 2);
            setSkeletonBlocks(blocks => blocks.map(item => ({
                ...item,
                rows: item.rows.map(row => ({
                    ...row,
                    visible: true,
                    width: Math.max(Math.round(width * Math.random()), Math.round(width2 * Math.random())),
                })),
            })));
        }
    }, []);
    const isDarkMode = useMemo(() => isDark(), []);
    const wrapperClass = useMemo(() => classNames(styles.wrapper, { [styles.dark]: isDarkMode }), [isDarkMode]);
    return (_jsx("div", { className: wrapperClass, ref: onInit, "data-testid": "rc-skeleton", style: style, children: skeletonBlocks.map(({ id, rows }) => (_jsxs("div", { className: classNames(styles.block, {
                [styles.block_rtl]: RTL,
            }), children: [showCircle && (_jsx("div", { className: classNames(styles.circle, {
                        [styles.dark]: isDarkMode,
                    }) })), rows.map(row => row.visible && (_createElement(SkeletonRow, { ...row, key: row.id, rowHeight: rowHeight, animate: animate, disableAnimation: !animate })))] }, id))) }));
};
Skeleton.displayName = 'Skeleton';
export { Skeleton };
